(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9603],{

/***/ 7716:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search",
      function () {
        return __webpack_require__(78537);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 78537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ search; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(35230);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/hooks/index.js + 13 modules
var hooks = __webpack_require__(98702);
// EXTERNAL MODULE: ./src/snippets/globals/layout/FilterBar.jsx
var FilterBar = __webpack_require__(51422);
// EXTERNAL MODULE: ./src/snippets/globals/layout/ProductGrid.jsx + 1 modules
var ProductGrid = __webpack_require__(5011);
// EXTERNAL MODULE: ./src/snippets/icons/Filter.jsx
var Filter = __webpack_require__(15776);
// EXTERNAL MODULE: ./src/snippets/components/CollectionHeader.jsx
var CollectionHeader = __webpack_require__(85634);
;// CONCATENATED MODULE: ./src/snippets/search/SearchPageContent.jsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







function SearchPageContent(param) {
    var _productHandles = param.productHandles, productHandles = _productHandles === void 0 ? [] : _productHandles, searchTerm = param.searchTerm;
    var ref;
    var sendViewSearchResultsEvent = (0,hooks/* useDataLayerActions */.KZ)().sendViewSearchResultsEvent;
    var ref1 = (0,hooks/* useProductsFromHandles */.tp)({
        handles: productHandles
    }), searchProducts = ref1.products;
    var products = (0,react.useMemo)(function() {
        return Object.values(_objectSpread({}, searchProducts));
    }, [
        searchProducts
    ]);
    var urlSearchParams = new URLSearchParams(document.location.search);
    var getFiltersFromUrl = function() {
        var filtersArray = [];
        var filters = urlSearchParams.get("filter");
        if (filters) filtersArray = filters.split("|");
        return filtersArray;
    };
    var ref2 = (0,react.useState)({
        searchQuery: urlSearchParams.get("search"),
        filters: getFiltersFromUrl()
    }), layoutParams = ref2[0], setLayoutParams = ref2[1];
    var ref3 = (0,react.useState)(false), mobileFilterOpen1 = ref3[0], setMobileFilterOpen = ref3[1];
    var filteredProducts = _toConsumableArray(products);
    if ((layoutParams === null || layoutParams === void 0 ? void 0 : (ref = layoutParams.filters) === null || ref === void 0 ? void 0 : ref.length) > 0) {
        filteredProducts = filteredProducts === null || filteredProducts === void 0 ? void 0 : filteredProducts.filter(function(product) {
            return product.tags.some(function(tag) {
                return layoutParams.filters.includes(tag);
            });
        });
    }
    var toggleMobileFilter = function() {
        setMobileFilterOpen(function(mobileFilterOpen) {
            var action = "remove";
            if (!mobileFilterOpen) {
                action = "add";
            }
            if (true) {
                document.querySelector("body").classList[action]("overflow-hidden");
            }
            return !mobileFilterOpen;
        });
    };
    (0,react.useEffect)(function() {
        sendViewSearchResultsEvent({
            products: products,
            isSearchPage: true,
            searchTerm: searchTerm
        });
    }, [
        products,
        sendViewSearchResultsEvent
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterBar/* default */.Z, {
                mobileFilterOpen: mobileFilterOpen1,
                setMobileFilterOpen: setMobileFilterOpen,
                currentFilters: layoutParams.filters,
                setLayoutParams: setLayoutParams,
                items: products,
                disableSort: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex gap-x-[120px] px-5 md:mx-auto lg:container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "collection__product-grid-container w-full lg:container lg:mx-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductGrid/* default */.Z, {
                        productList: filteredProducts,
                        isSearch: true
                    })
                })
            }, "collection-container")
        ]
    });
}
/* harmony default export */ var search_SearchPageContent = (SearchPageContent);

;// CONCATENATED MODULE: ./src/snippets/search/SearchPage.jsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




function SearchPage() {
    var ref2 = (0,react.useState)(null), productHandles = ref2[0], setProductHandles = ref2[1];
    var urlSearchParams = new URLSearchParams(document.location.search);
    var searchTerm = urlSearchParams.get("search");
    (0,react.useEffect)(function() {
        var searchShopify = function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee(term) {
                var ref, ref1, options, request, response, shopifyProducts, searchProductHandles;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            options = {
                                method: "POST",
                                body: JSON.stringify({
                                    term: term
                                })
                            };
                            _ctx.next = 5;
                            return fetch("/api/shopify/search", options);
                        case 5:
                            request = _ctx.sent;
                            _ctx.next = 8;
                            return request.json();
                        case 8:
                            response = _ctx.sent.response;
                            shopifyProducts = (response === null || response === void 0 ? void 0 : (ref = response.results) === null || ref === void 0 ? void 0 : ref.products) || [];
                            searchProductHandles = (ref1 = shopifyProducts === null || shopifyProducts === void 0 ? void 0 : shopifyProducts.filter(function(p) {
                                return !p.tags.includes("findify-remove");
                            })) === null || ref1 === void 0 ? void 0 : ref1.map(function(product) {
                                return product.handle;
                            });
                            setProductHandles(searchProductHandles);
                            _ctx.next = 18;
                            break;
                        case 14:
                            _ctx.prev = 14;
                            _ctx.t0 = _ctx["catch"](0);
                            console.error("searchShopify:error", _ctx.t0);
                            return _ctx.abrupt("return", []);
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        14
                    ]
                ]);
            }));
            return function searchShopify(term) {
                return _ref.apply(this, arguments);
            };
        }();
        if (searchTerm) {
            searchShopify(searchTerm);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h3 px-5 lg:container lg:mx-auto",
                children: searchTerm ? 'All search results for "'.concat(searchTerm, '"') : "No search term specified"
            }),
            productHandles && productHandles.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(search_SearchPageContent, {
                productHandles: productHandles,
                searchTerm: searchTerm
            }, searchTerm)
        ]
    });
}
/* harmony default export */ var search_SearchPage = (SearchPage);

;// CONCATENATED MODULE: ./src/pages/search.jsx



function Search() {
    // loaded state necessary to avoid hydration errors due to ssr and yotpo replacing the html
    var ref = (0,react.useState)(false), loaded = ref[0], setLoaded = ref[1];
    (0,react.useEffect)(function() {
        setLoaded(true);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "py-10",
        children: loaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(search_SearchPage, {})
    });
}
var __N_SSG = true;
/* harmony default export */ var search = (Search);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(7716); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);